<script>
import store from '../Store/store'

export default {
  name: 'QuestionTitle',

  computed: {
    isActive() {
      return store.getters['questions/isActiveQuestionIndex'](this.$attrs.questionindex)
    }
  },

  methods: {
    updateActiveQuestion(index) {
      store.dispatch('questions/updateActiveQuestion', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.question__title {
  color: rgb(104, 184, 33);
  font-size: 16px;
  line-height: 1.4;
  cursor: pointer;

  i {
    margin-left: 5px;
    transition: transform 0.2s ease-in-out;
  }

  &--active {
    i {
      transform: rotate(90deg);
    }
  }
}
</style>
